import type { ComponentType } from "react";

import { MESSAGE_TYPE } from "@/constants/message";
import type { Message } from "@/types/message";
import { MessageBubble, messageBubbleVariants } from "./message-bubble";

export type MessageComponentProps = {
  message: Message;
};

const { root, timestamp } = messageBubbleVariants();

export const ClinicianMessage = ({ message }: MessageComponentProps) => {
  return (
    <MessageBubble.Root className={root({ variant: "clinician" })} message={message}>
      <MessageBubble.SenderName />
      <MessageBubble.Content />
      <MessageBubble.Timestamp className={timestamp({ variant: "clinician" })} />
    </MessageBubble.Root>
  );
};

export const UserMessage = ({ message }: MessageComponentProps) => {
  return (
    <MessageBubble.Root className={root({ variant: "user" })} message={message}>
      <MessageBubble.SenderName />
      <MessageBubble.Content />
      <MessageBubble.Timestamp className={timestamp({ variant: "user" })} />
    </MessageBubble.Root>
  );
};

export const SystemMessage = ({ message }: MessageComponentProps) => {
  return (
    <MessageBubble.Root className={root({ variant: "system" })} message={message}>
      <MessageBubble.SenderName />
      <MessageBubble.Content />
      <MessageBubble.Timestamp className={timestamp({ variant: "system" })} />
    </MessageBubble.Root>
  );
};

export const EventMessage = ({ message }: MessageComponentProps) => {
  return (
    <MessageBubble.Root className={root({ variant: "event" })} message={message}>
      <MessageBubble.Timestamp className={timestamp({ variant: "event" })} />
      <MessageBubble.Content />
    </MessageBubble.Root>
  );
};

export const messageTypeToComponentMap: Record<
  Message["type"],
  ComponentType<MessageComponentProps>
> = {
  [MESSAGE_TYPE.clinician]: ClinicianMessage,
  [MESSAGE_TYPE.user]: UserMessage,
  [MESSAGE_TYPE.system]: SystemMessage,
  [MESSAGE_TYPE.event]: EventMessage,
};
